module.exports = __webpack_public_path__ + "static/media/moderate.b6c73c4a.png";